import * as selectors from './selectors'
import reducer from './reducer'

export { selectors }
export const { setActiveClientId, setUserClients, setActiveClientIdStarted } =
  reducer.actions
export default reducer
